import React, { Component } from "react";

const COMPANY_ICONS = {
  "AT7 Studio | Jaguar Games": "🏢",
  "Woznics": "🌐",
  "Pixel Perfect Studio": "🎮",
  "Tec de Monterrey": "🎓",
  "ICHI Services": "🤖",
};

class Experience extends Component {
  componentDidMount() {
    this.attachObserver();
  }

  componentDidUpdate() {
    this.attachObserver();
  }

  attachObserver() {
    if (this._obsAttached) return;
    const items = document.querySelectorAll(".tl-item");
    if (!items.length) return;
    this._obsAttached = true;

    const obs = new IntersectionObserver(
      (entries) => {
        entries.forEach((e) => {
          if (e.isIntersecting) {
            e.target.classList.add("in");
            obs.unobserve(e.target);
          }
        });
      },
      { threshold: 0, rootMargin: "0px 0px -30px 0px" }
    );
    items.forEach((el, i) => {
      el.style.transitionDelay = `${i * 0.1}s`;
      obs.observe(el);
    });
  }

  render() {
    let sectionName = "Experience";
    let ui = {};
    let work = null;

    if (this.props.resumeExperience && this.props.resumeBasicInfo) {
      sectionName = this.props.resumeBasicInfo.section_name.experience;
      ui = this.props.resumeBasicInfo.ui || {};
      work = this.props.resumeExperience
        .filter((w) => !w.hidden)
        .sort((a, b) => {
          const parseEnd = (years) => {
            const parts = years.split(/\s*[–\-]\s*/);
            const end = parts[parts.length - 1].trim();
            if (end.toLowerCase().includes("present")) return Infinity;
            const m = end.match(/^(\d{2})\.(\d{4})/);
            return m ? parseInt(m[2]) * 12 + parseInt(m[1]) : 0;
          };
          return parseEnd(b.years) - parseEnd(a.years);
        })
        .map((w, i) => {
          const isNow = w.years.toLowerCase().includes("present");
          const icon = COMPANY_ICONS[w.company] || "💼";
          return (
            <div className="tl-item" key={i}>
              <div className="tl-dot">{icon}</div>
              <div className="tl-card">
                <div className="tl-head">
                  <div className="tl-company">{w.company}</div>
                  <div className={`tl-period${isNow ? " now" : ""}`}>
                    {w.years}
                  </div>
                </div>
                <div className="tl-role">{w.title}</div>
                <div className="tl-tags">
                  {w.technologies.map((t, j) => (
                    <span className="tl-tag" key={j}>
                      {t}
                    </span>
                  ))}
                </div>
              </div>
            </div>
          );
        });
    }

    return (
      <section id="experience">
        <div style={{ maxWidth: "1100px", margin: "0 auto" }}>
          <p className="sec-eye rv">{ui.exp_eyebrow || "My Backstory"}</p>
          <h2 className="sec-h rv" style={{ transitionDelay: ".05s" }}>
            {ui.exp_prefix || "WORK"} <span>{sectionName}</span>
          </h2>
          <div className="timeline">{work}</div>
        </div>
      </section>
    );
  }
}

export default Experience;
